import React from 'react';
import { Card, CardBody, CardTitle, Col, Row } from 'reactstrap';

const StreamInfo = ({ streamInfo }) => {
    return (
        <Card className="mb-4">
            <CardBody>
                <CardTitle tag="h5" style={{ color: "#6691e7" }}>Stream Information</CardTitle>
                <hr />
                <Row>
                    <Col md={4} className="mb-3">
                        <div>
                            <strong>Available Bitrates:</strong>
                            <div className="text-muted">{streamInfo.availableBitrates}</div>
                        </div>
                    </Col>
                    <Col md={4} className="mb-3">
                        <div>
                            <strong>Available Resolutions:</strong>
                            <div className="text-muted">{streamInfo.availableResolutions}</div>
                        </div>
                    </Col>
                    <Col md={4} className="mb-3">
                        <div>
                            <strong>Current Resolution:</strong>
                            <div className="text-muted">{streamInfo.currentResolution}</div>
                        </div>
                    </Col>
                    <Col md={4} className="mb-3">
                        <div>
                            <strong>Segment Length:</strong>
                            <div className="text-muted">{streamInfo.segmentLength}</div>
                        </div>
                    </Col>
                    <Col md={4} className="mb-3">
                        <div>
                            <strong>FPS:</strong>
                            <div className="text-muted">{streamInfo.fps}</div>
                        </div>
                    </Col>
                    <Col md={4} className="mb-3">
                        <div>
                            <strong>Buffer:</strong>
                            <div className="text-muted">{streamInfo.buffer}</div>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );
};

export default StreamInfo;

